import React from 'react';
import { Box, Typography } from '@mui/material';
import { STATUS_COLORS } from './toAppointmentEvent';
import { BLOCK_COLOR } from './agendaBlock/toBlockEvent';
import { PERSONAL_EVENT_COLOR } from './personalEvent/toPersonalEvent';

// Uses the same color constants as the calendar events, so the legend never drifts from the agenda.
const LEGEND_ITEMS = [
  { color: STATUS_COLORS.SCHEDULED, label: 'Agendada' },
  { color: STATUS_COLORS.CONFIRMED, label: 'Confirmada' },
  { color: STATUS_COLORS.PERFORMED, label: 'Realizada' },
  { color: STATUS_COLORS.NO_SHOW, label: 'Falta do paciente' },
  { color: STATUS_COLORS.CANCELED, label: 'Cancelada' },
  { color: BLOCK_COLOR, label: 'Horário bloqueado' },
  { color: PERSONAL_EVENT_COLOR, label: 'Compromisso pessoal' },
];

export default function AppointmentStatusLegend() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        columnGap: 2,
        rowGap: 0.5,
        mb: 1,
      }}
    >
      {LEGEND_ITEMS.map((item) => (
        <Box key={item.label} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <span className="agenda-legend-swatch" style={{ backgroundColor: item.color }} />
          <Typography variant="caption" color="text.secondary">
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
